<template>
    <div class='container d-grid category'>
        <div class="menu">
            <div class="list">
                <ul class="list-ul list-unstyled mb-0" id="category-list">
                    <li class="list-li">
                        <a href="/"><i class="icon-new_back md-16"></i>首頁</a>
                    </li>
                    <li class="list-li">
                        <router-link to="/about"><i class="icon-new_about md-16"></i>關於</router-link>
                    </li>
                    
                    <li class="list-li" v-for="item in cate" :key="item.cate_name" @click="is_active(item);">
                        <a href="javascript:;" class="">
                            <span>{{ item.cate_name }}</span>
                        </a>
                    </li>
                    <li class="list-li">
                        <router-link to="/announcement">防詐騙公告</router-link>
                    </li>
                    <li class="list-li" v-for="item in getnav" :key="item.name" @click=" gonav(item)">
                        <a href="javascript:;">
                            <span>{{ item.name }} </span>
                        </a>

                    </li>
                    
                    <li class="list-li">
                        <router-link to="/check_order">訂單查詢</router-link>
                    </li>
                </ul>

            </div>
        </div>
        <div class="shop">
            <router-view :key="$route.fullPath"></router-view>
        </div>

    </div>
</template>
<script>
import $ from 'jquery'
import { mapState } from 'vuex'
export default {
    components: {},
    data() {
        return {
        };
    },
    computed: {
        ...mapState('header', ['cate', 'getnav'])
    },
    watch: {},
    methods: {
        is_active(e) {
            this.$store.dispatch('commodity/getclassification', e.cid).then(response => {
                this.$router.push({
                    path: `/category_list/${e.cid}/${e.cate_name}`,
                }).catch(err => { })
                location.reload();
            });
        },
        // 选中高亮
        is_actives(e) {

            $('#navbar-nav')[0].childNodes.forEach(element => {
                $(element).removeClass('active')
            });
            $(e.currentTarget).addClass('active');

        },
        gonav(e) {
            // console.log(e);
            this.$router.push({
                path: `/nav/${e.name}`,
            }).catch(err => {

            })
            this.$store.commit('header/SET_NAVCONTENT',e)
        },
    },
    created() {
    },
    mounted() {
    },
}
</script>
<style lang='scss' scoped src="./index.scss"></style>